import { useEffect } from "react";
import Lenis from "lenis";
import { scrollToId } from "../App";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import Marquee from "../components/Marquee";
import Expertise from "../components/Expertise";
import ImageBreak from "../components/ImageBreak";
import Approach from "../components/Approach";
import CtaSection from "../components/CtaSection";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const go = () => {
      const id = window.location.hash.slice(1);
      if (!id) return;
      let tries = 0;
      const attempt = () => {
        if (document.getElementById(id)) {
          scrollToId(id);
          // Re-scroll after images/layout settle so the target stays accurate
          setTimeout(() => scrollToId(id), 1200);
          setTimeout(() => scrollToId(id), 2500);
        } else if (tries++ < 15) {
          setTimeout(attempt, 200);
        }
      };
      setTimeout(attempt, 300);
    };
    go();
    window.addEventListener("hashchange", go);
    return () => window.removeEventListener("hashchange", go);
  }, []);

  return (
    <div className="bg-ivory text-ink antialiased" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Intro />
        <Marquee />
        <Expertise />
        <ImageBreak />
        <Approach />
        <CtaSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
